import { useTranscriptExpansion } from "./TranscriptContext";
import { Fragment } from "react/jsx-runtime";
import type { GroupedEntry } from "./groupChatEntries";
import { Message } from "./transcriptStyles";
import { UserActionGroup } from "./UserActionGroup";

type Props = {
  grouped: Extract<GroupedEntry, { type: "userActionGroup" }>;
  dateMarker: React.ReactNode;
  hasPrev: boolean;
  hasNext: boolean;
  activityAbove: boolean;
};

export function UserActionGroupRow({
  grouped,
  dateMarker,
  hasPrev,
  hasNext,
  activityAbove,
}: Props) {
  const { expandedUserActionGroups, setExpandedUserActionGroups } =
    useTranscriptExpansion();
  return (
    <Fragment>
      {dateMarker}
      <Message
        style={{
          marginTop: hasPrev && !activityAbove ? 16 : 0,
          marginBottom: hasNext ? 32 : 0,
        }}
      >
        <UserActionGroup
          entries={grouped.entries}
          collapsed={!expandedUserActionGroups.has(grouped.groupId)}
          toggleCollapsed={() =>
            setExpandedUserActionGroups((prev) => {
              const next = new Set(prev);
              if (next.has(grouped.groupId)) {
                next.delete(grouped.groupId);
              } else {
                next.add(grouped.groupId);
              }
              return next;
            })
          }
        />
      </Message>
    </Fragment>
  );
}
